import React, { useEffect, useRef, useState } from 'react';

import './caroumal-style.css';

const Caroumal = (props) => {
  const { children } = props;
  const options = {
    className: props.className ? props.className : null,
    id: props.id ? props.id : null,
    nextElement: props.nextElement ? props.nextElement : null,
    prevElement: props.prevElement ? props.prevElement : null,
    rtl: props.rtl === undefined ? false : props.rtl,
    arrows: props.arrows === undefined ? true : props.arrows,
    dots: props.dots === undefined ? false : props.dots,
    draggable: props.draggable === undefined ? true : props.draggable,
    autoWidth: props.autoWidth === undefined ? true : props.autoWidth,
    startIndex: props.startIndex ? props.startIndex : 1,
    items: props.items ? props.items : 1,
    minMoveToToggle: props.minMoveToToggle ? props.minMoveToToggle : 30,
    responsive: Array.isArray(props.responsive) ? props.responsive : null,
  };

  const [arrowEnable, setArrowEnable] = useState(options.arrows);
  const [haveNext, setHaveNext] = useState(false);
  const [havePrev, setHavePrev] = useState(false);
  const [dotsEnable, setDotsEnable] = useState(options.dots);
  const [index, setIndex] = useState(options.startIndex);

  const bodyRef = useRef();
  const listRef = useRef();
  const nextRef = useRef();
  const prevRef = useRef();
  const dotsRef = useRef();

  const getMatrix = (element) => {
    const values = element.style.transform.split(/\w+\(|\);?/);
    if (values[1]) {
      const transform = values[1].split(/,\s?/g).map((numStr) => parseInt(numStr));

      return {
        x: transform[0],
        y: transform[1],
        z: transform[2],
      };
    } else {
      return {
        x: 0,
        y: 0,
        z: 0,
      };
    }
  };

  const handleEventPrevent = (e) => {
    e.preventDefault();
    return false;
  };

  // **********************************************************************************************************************************************
  const start = () => {
    const bodyWidth = bodyRef.current.offsetWidth;
    const _setting = {
      index: options.startIndex,
      isDown: false,
      startPageX: null,
      startTranslateX: null,
      target: { node: null, eventSet: false },
      haveNext: false,
      havePrev: false,
      moveDirect: null,
      action: null,
      dots: [],
    };

    // Set items width
    if (!options.autoWidth) {
      const itemWidth = bodyWidth / options.items;
      for (let i = 0; i < listRef.current.childNodes.length; i++) {
        listRef.current.childNodes[i].style.width = itemWidth + 'px';
      }
    }

    // Set list width after specific the items width.
    const listWidth = listRef.current.offsetWidth;

    if (options.draggable) {
      const finallyDragSetting = () => {
        const translate = getMatrix(listRef.current);
        let move = 0;

        for (let i = 0; i < listRef.current.children.length; i++) {
          const itemWidth = listRef.current.children[i].offsetWidth;
          if (move + itemWidth === translate.x) {
            _setting.index = i + 2;
            setIndex(i + 2);
            break;
          } else if (move + itemWidth < translate.x) {
            move += itemWidth;
          } else {
            const moveFromCurrentItem = translate.x - move;
            const minMove = parseInt((itemWidth * options.minMoveToToggle) / 100);

            if (_setting.moveDirect === 'next') {
              _setting.index = i + 1;

              if (moveFromCurrentItem > minMove) {
                move += itemWidth;
                _setting.index = _setting.index + 1;
              }
            }
            if (_setting.moveDirect === 'prev') {
              _setting.index = i + 1; // +1 because we get back in list.

              if (itemWidth - moveFromCurrentItem < minMove) {
                move = move + itemWidth;
                /*
                                if [itemWidth - moveFromCurrentItem < minMove] list dont get back and list items not change.
                                so we inc _setting.index +1 to get current index.
                                 */
                _setting.index = _setting.index + 1;
              }
            }

            setIndex(_setting.index);

            if (_setting.index > 1) {
              setHavePrev(true);
              _setting.havePrev = true;
            } else {
              setHavePrev(false);
              _setting.havePrev = false;
            }
            if (move >= Math.abs(listRef.current.offsetLeft)) {
              _setting.haveNext = false;
              setHaveNext(false);
            } else {
              _setting.haveNext = true;
              setHaveNext(true);
            }

            listRef.current.style.transform = `translate3d(${move}px, ${translate.y}px, ${translate.z}px)`;

            break;
          }
        }

        if (_setting.dots.length) {
          const oldActiveDot = dotsRef.current.querySelector('.caroumal-dot.active');
          if (oldActiveDot) {
            oldActiveDot.classList.remove('active');
          }
          dotsRef.current.children[_setting.index - 1].classList.add('active');
        }
      };

      const dragInit = (e) => {
        if (e.type === 'touchstart') {
          if (e.touches.length === 1) {
            const translate = getMatrix(listRef.current);
            _setting.action = 'touch';
            _setting.isDown = true;
            _setting.startPageX = e.touches[0].pageX;
            _setting.startTranslateX = translate.x;
            listRef.current.classList.remove('animate');
          }
        } else if (e.type === 'mousedown') {
          e.preventDefault();
          const translate = getMatrix(listRef.current);
          _setting.action = 'mouse';
          _setting.isDown = true;
          _setting.startPageX = e.pageX;
          _setting.startTranslateX = translate.x;
          _setting.target.node = e.target;
          listRef.current.classList.remove('animate');
        }
      };

      const dragStart = (e) => {
        if (_setting.isDown) {
          if (_setting.action === 'touch' && e.type === 'touchmove') {
            e.preventDefault();

            const listOffsetLeft = Math.abs(listRef.current.offsetLeft);
            const translate = getMatrix(listRef.current);
            let translateX;
            let move = e.touches[0].pageX - _setting.startPageX;
            if (options.rtl) {
              move *= -1;
            }

            if (move < 0) {
              // next
              _setting.moveDirect = 'next';
              translateX = _setting.startTranslateX + Math.abs(move);
              if (translateX >= listOffsetLeft) {
                translateX = listOffsetLeft;
              }
            } else {
              // prev
              _setting.moveDirect = 'prev';
              translateX = _setting.startTranslateX - move;
              if (translateX < 0) {
                translateX = 0;
              }
            }

            listRef.current.style.transform = `translate3d(${translateX}px, ${translate.y}px, ${translate.z}px)`;
          } else if (_setting.action === 'mouse') {
            e.preventDefault();
            if (!_setting.target.eventSet) {
              _setting.target.node.addEventListener('click', handleEventPrevent);
              _setting.target.eventSet = true;
            }

            const listOffsetLeft = Math.abs(listRef.current.offsetLeft);
            const translate = getMatrix(listRef.current);
            let translateX;
            let move = e.pageX - _setting.startPageX;
            if (options.rtl) {
              move *= -1;
            }

            if (move < 0) {
              // next
              _setting.moveDirect = 'next';
              translateX = _setting.startTranslateX + Math.abs(move);
              if (translateX >= listOffsetLeft) {
                translateX = listOffsetLeft;
              }
            } else {
              // prev
              _setting.moveDirect = 'prev';
              translateX = _setting.startTranslateX - move;
              if (translateX < 0) {
                translateX = 0;
              }
            }

            listRef.current.style.transform = `translate3d(${translateX}px, ${translate.y}px, ${translate.z}px)`;
          }
        }
      };

      const dragEnd = () => {
        if (_setting.isDown) {
          listRef.current.classList.add('animate');
          finallyDragSetting();

          _setting.isDown = false;
          _setting.startPageX = null;
          _setting.startPageX = null;
          _setting.moveDirect = null;
          _setting.action = null;

          if (_setting.target.eventSet) {
            setTimeout(() => {
              _setting.target.node.removeEventListener('click', handleEventPrevent);
              _setting.target.node = null;
              _setting.target.eventSet = false;
            }, 0);
          }
        }
      };

      listRef.current.addEventListener('mousedown', dragInit);
      listRef.current.addEventListener('mousemove', dragStart);
      listRef.current.addEventListener('mouseleave', dragEnd);
      listRef.current.addEventListener('mouseup', dragEnd);
      listRef.current.addEventListener('touchstart', dragInit);
      listRef.current.addEventListener('touchmove', dragStart);
      listRef.current.addEventListener('touchend', dragEnd);
      listRef.current.addEventListener('touchcancel', dragEnd);
    }

    if (options.arrows) {
      if (listWidth > bodyWidth) {
        setArrowEnable(true);
        setHaveNext(true);
        _setting.haveNext = true;
      }

      nextRef.current.addEventListener('click', () => {
        if (_setting.haveNext) {
          const translate = getMatrix(listRef.current);
          const itemWidth = listRef.current.children[_setting.index].offsetWidth;
          const listOffsetLeft = Math.abs(listRef.current.offsetLeft);
          const translateX = translate.x + itemWidth;

          listRef.current.style.transform = `translate3d(${translateX}px, ${translate.y}px, ${translate.z}px)`;

          if (!_setting.havePrev) {
            _setting.havePrev = true;
            setHavePrev(true);
          }

          _setting.index = _setting.index + 1;
          setIndex(_setting.index);
          if (translateX >= listOffsetLeft) {
            _setting.haveNext = false;
            setHaveNext(false);
          }

          if (_setting.dots.length) {
            const oldActiveDot = dotsRef.current.querySelector('.caroumal-dot.active');
            if (oldActiveDot) {
              oldActiveDot.classList.remove('active');
            }
            dotsRef.current.children[_setting.index - 1].classList.add('active');
          }
        }
      });

      prevRef.current.addEventListener('click', () => {
        if (_setting.havePrev) {
          const translate = getMatrix(listRef.current);
          const itemWidth = listRef.current.children[_setting.index - 1].offsetWidth;

          let translateX = translate.x - itemWidth;
          if (translateX < 0) {
            translateX = 0;
          }

          listRef.current.style.transform = `translate3d(${translateX}px, ${translate.y}px, ${translate.z}px)`;

          if (!_setting.haveNext) {
            _setting.haveNext = true;
            setHaveNext(true);
          }

          _setting.index = _setting.index - 1;
          setIndex(_setting.index);
          if (translateX === 0) {
            _setting.havePrev = false;
            setHavePrev(false);
          }

          if (_setting.dots.length) {
            const oldActiveDot = dotsRef.current.querySelector('.caroumal-dot.active');
            if (oldActiveDot) {
              oldActiveDot.classList.remove('active');
            }
            dotsRef.current.children[_setting.index - 1].classList.add('active');
          }
        }
      });
    }

    if (options.dots && listWidth > bodyWidth) {
      setDotsEnable(true);

      // Get dot list.
      const listOffsetLeft = Math.abs(listRef.current.offsetLeft);
      let itemsWidth = 0;
      for (let i = 0; i < listRef.current.children.length; i++) {
        _setting.dots.push({
          index: i + 1,
          translateX: itemsWidth,
        });

        itemsWidth += listRef.current.children[i].offsetWidth;

        if (itemsWidth >= listOffsetLeft) {
          _setting.dots.push({
            index: i + 2,
            translateX: itemsWidth,
          });
          break;
        }
      }

      // Create dots
      for (let i = 1; i <= _setting.dots.length; i++) {
        const dot = document.createElement('button');
        dot.setAttribute('type', 'button');
        dot.setAttribute('class', `caroumal-dot ${i === _setting.index ? 'active' : ''}`);
        dot.innerHTML = '<span/>';

        dotsRef.current.appendChild(dot);

        dot.addEventListener('click', (e) => {
          _setting.index = i;
          const translate = getMatrix(listRef.current);
          listRef.current.style.transform = `translate3d(${_setting.dots[i - 1].translateX}px, ${translate.y}px, ${translate.z}px)`;

          const oldActiveDot = dotsRef.current.querySelector('.caroumal-dot.active');
          if (oldActiveDot) {
            oldActiveDot.classList.remove('active');
          }

          dotsRef.current.children[i - 1].classList.add('active');

          if (_setting.index > 1) {
            setHavePrev(true);
            _setting.havePrev = true;
          } else {
            setHavePrev(false);
            _setting.havePrev = false;
          }
          if (_setting.dots[i - 1].translateX >= Math.abs(listRef.current.offsetLeft)) {
            _setting.haveNext = false;
            setHaveNext(false);
          } else {
            _setting.haveNext = true;
            setHaveNext(true);
          }
        });
      }
    }
  };
  // **********************************************************************************************************************************************

  useEffect(() => {
    start();
  }, []);

  return (
    <div
      className={`caroumal ${options.rtl ? 'caroumal-rtl' : 'caroumal-ltr'} ${options.className}`}
      id={options.id ? options.id : ''}
    >
      <div className="caroumal-body" ref={bodyRef}>
        <div className="caroumal-list animate" ref={listRef}>
          {children.map((item, i) => {
            return (
              <div className="caroumal-item" key={'cmi' + i}>
                {item}
              </div>
            );
          })}
        </div>
      </div>

      <button
        type="button"
        role="presentation"
        ref={prevRef}
        className={`caroumal-arrows ${arrowEnable ? 'show' : ''} caroumal-prev ${havePrev ? 'active' : 'disabled'}`}
      >
        {options.prevElement ? options.prevElement : <span className="icon" aria-label="Next" />}
      </button>

      <button
        type="button"
        role="presentation"
        ref={nextRef}
        className={`caroumal-arrows ${arrowEnable ? 'show' : ''} caroumal-next ${haveNext ? 'active' : 'disabled'}`}
      >
        {options.nextElement ? options.nextElement : <span className="icon" aria-label="Next" />}
      </button>

      <div className={`caroumal-dots ${dotsEnable ? 'show' : ''}`} ref={dotsRef} />
    </div>
  );
};

export default Caroumal;
